import React, { useState } from "react";
import libfav from "../../assets/libfav.png";
import libnotes from "../../assets/libnotes.png";
import libhighlight from "../../assets/libhighlights.png";
import { NotesCard } from "../../models/NotesCard/NotesCard";
import { useNavigate } from "react-router-dom";
import "./Library.css";
import { useAuthContext } from "../../context/AuthContext";
import { Toaster } from "react-hot-toast";
import { PopUpShowMore } from "../../models/PopupShowMore/PopupShowMore";
import nohighlights from "../../assets/nohighlights.png";
import { FiChevronDown } from "react-icons/fi";
import Pagination from "@mui/material/Pagination";

export const Notes = () => {
	const closenotePopup = () => setNotesPopup(false);
	const opennotePopup = (data) => {
		setNotepopupdata(data);
		setNotesPopup(true);
	};

	const [notesPopup, setNotesPopup] = useState(false);
	const [sortop, setSortop] = useState(2);
	const [notepopupdata, setNotepopupdata] = useState({});

	const navigate = useNavigate();
	const { notes, changeNotes, notesPersist } = useAuthContext();
	console.log(notes);
	const [currentPage, setCurrentPage] = useState(1);
	const [postsperpage, setPostsperpage] = useState(6);
	const indexoflast = currentPage * postsperpage;
	const indexoffirst = indexoflast - postsperpage;

	return (
		<div className="LibraryPage">
			<Toaster />
			
			{notesPopup && (
				<PopUpShowMore
					data={notepopupdata}
					handleClose={closenotePopup}
				></PopUpShowMore>
			)}
			<div className="libraryoption">
				<div
					className="libraryopitem"
					onClick={() => {
						navigate("/favourites");
					}}
				>
					<img src={libfav} className="lbopic" />
					<span>Favourites</span>
				</div>
				<div
					className="libraryopitem"
					onClick={() => {
						navigate("/notes");
					}}
				>
					<img src={libnotes} className="lbopic" />
					<span style={{ color: "#435CFF" }}>Notes </span>
				</div>
				<div
					className="libraryopitem"
					onClick={() => {
						navigate("/hightlights");
					}}
				>
					<img src={libhighlight} className="lbopic" />
					<span>Highlights</span>
				</div>
			</div>
			<div className="opandfildivider"></div>
			<div className="filteroption">
				<div className="libraryopitem">
					{" "}
					<select
						
						name=""
						id=""
						style={{ paddingRight: "40px" }}
						onChange={(e) => {
							if (e.target.value == "All Beam") {
								console.log(notesPersist);
								changeNotes(notesPersist);
							} else {
								const sorter = notesPersist.filter((h) => {
									return h.Beamtype == e.target.value;
								});

								changeNotes(sorter);
							}
						}}
					>
						<option disabled defaultValue={""}>
							Title
						</option>
						<option value="All Beam">All Beams</option>
						<option value="Microbeam">Micro Beams</option>
						<option value="Minibeam">Mini Beams</option>
					</select>
					<FiChevronDown className="arrowselectposition" />
				</div>

				<div className="libraryopitem">
					<span style={{ color: "black" }}>Sort By</span>
					<select
						name=""
						id=""
						onChange={(e) => {
							
							setSortop(e.target.value);
						}}
						style={{ paddingRight: "40px" }}
					>
						<option defaultValue={2} value={2}>
							Latest
						</option>
						<option value={0}>A-Z</option>
						<option value={1}>Z-A</option>
					</select>
					<FiChevronDown className="arrowselectposition" />
				</div>
			</div>
			{notes.length != 0 ? (
				<div>
					<div className="gridwrapper">
						{sortop == 1 && (
							<div className="highlightdata fwrap">
								{notes
									.sort((a, b) => {
										const nameA = a.BeamName.toUpperCase(); // ignore upper and lowercase
										const nameB = b.BeamName.toUpperCase(); // ignore upper and lowercase
										if (nameA > nameB) {
											return -1;
										}
										if (nameA < nameB) {
											return 1;
										}

										return 0;
									})
									.map((item) => {
										return (
											<NotesCard
												date={item.Date}
												NoteContent={item.NoteContent}
												noteitemid={item.id}
												beamid={item.beamid}
												BeamName={item.BeamName}
												readmore={opennotePopup}
											></NotesCard>
										);
									})
									.slice(indexoffirst, indexoflast)}
							</div>
						)}
						{sortop == 0 && (
							<div className="highlightdata fwrap">
								{notes
									.sort((a, b) => {
										const nameA = a.BeamName.toUpperCase(); // ignore upper and lowercase
										const nameB = b.BeamName.toUpperCase(); // ignore upper and lowercase
										if (nameA < nameB) {
											return -1;
										}
										if (nameA > nameB) {
											return 1;
										}

										return 0;
									})
									.map((item) => {
										return (
											<NotesCard
												date={item.Date}
												NoteContent={item.NoteContent}
												noteitemid={item.id}
												beamid={item.beamid}
												BeamName={item.BeamName}
												readmore={opennotePopup}
											></NotesCard>
										);
									})
									.slice(indexoffirst, indexoflast)}
							</div>
						)}
						{sortop == 2 && (
							<div className="highlightdata fwrap">
								{notes
									.map((item) => {
										return (
											<NotesCard
												date={item.Date}
												NoteContent={item.NoteContent}
												noteitemid={item.id}
												beamid={item.beamid}
												BeamName={item.BeamName}
												readmore={opennotePopup}
											></NotesCard>
										);
									})
									.slice(indexoffirst, indexoflast)}
							</div>
						)}
					</div>
				</div>
			) : (
				<div
					style={{
						width: "100%",
						justifyContent: "center",
						alignItems: "center",
						display: "flex",
						flexDirection: "column",
						marginTop: "50px"
					}}
					className="nodatadiv"
				>
					<img src={nohighlights} alt="" />
					<h2 style={{ marginTop: "30px", fontSize: "30px" }}>
						You haven't added any highlights yet.
					</h2>
					<p style={{ marginTop: "20px" }}>
						Make highlights the highlight of your day.
					</p>
				</div>
			)}
			<div className="pagination">
				<Pagination
					shape="rounded"
					count={Math.ceil(notes.length / postsperpage)}
					onChange={(e, page) => {
						setCurrentPage(page);
					}}
				/>
			</div>
		</div>
	);
};
